/* eslint-disable */
import {
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Tr,
  useColorModeValue,
  Center,
  useToast,
  Grid,
  Box,
  Image,
  Badge,
  Stack,
  Checkbox,
} from "@chakra-ui/react";
// Custom components
import Card from "components/card/Card";
import { HSeparator } from "components/separator/Separator";
import React, { useEffect, useState } from "react";
import { convertDate, URL_WEB_BACKEND } from "CustomUtil";
import axios from "axios";
import { useParams } from "react-router-dom";
import FileViewer from "./FileViewer";

export default function Verifikasi() {
  const { verifid } = useParams();


  const textColor = useColorModeValue("secondaryGray.900", "white");

  const [statusLoading, setStatusLoading] = useState(true);
  const [sumas, setSumas] = useState({});
  const toast = useToast();

  useEffect(() => {
    getSumas(verifid);
  }, []);

  const getSumas = async (id) => {
    setStatusLoading(true);
    await axios.get(URL_WEB_BACKEND + '/getsumabyverifid/' + id, {
      headers: {}
    }).then((response) => {
      setSumas(response.data);
      setStatusLoading(false);
    }).catch(err => {
      setStatusLoading(false);
      toast({
        status: 'error',
        title: 'Error status ' + err.response.status,
        description: 'Data tidak ditemukan.',
        position: 'bottom-right',
        isClosable: true,
      })
    });
  }

  return (
    <Card
      direction='column'
      w='100%'
      px='0px'
      overflowX={{ sm: "scroll", lg: "hidden" }}>
      <Flex px='25px' justify='space-between' mb='20px' align='center'>
        <Text
          color={textColor}
          fontSize='22px'
          fontWeight='700'
          lineHeight='100%'>
          LPP Yogyakarta {"->"} Disposisi Surat Masuk
        </Text>
      </Flex>
      {statusLoading ? <Center mb={10} mt={10}><Text color={textColor} fontSize='22px' fontWeight='700' lineHeight='100%'>Mohon Tunggu...</Text></Center> : <Table variant='unstyled'>
        <Tbody>
          {!sumas.id
            ? <Tr><Td><Center mb={10} mt={10}><Text color={textColor} fontSize='22px' fontWeight='700' lineHeight='100%'>SURAT TIDAK TERDAFTAR</Text></Center></Td></Tr>
            : <>
              <Tr >
                <Td>
                  <Card direction="row" p='6' boxShadow="md" m='2' borderRadius="lg">
                    {sumas.isidisposisi !== '' || sumas.disposisike !== '' ? <Badge colorScheme="green" width='30%' marginBottom={5}>SUDAH DISPOSISI</Badge> : <Badge colorScheme="red" width='30%' marginBottom={5}>BELUM DISPOSISI</Badge>}
                    <Grid templateColumns="repeat(2, 1fr)" gap={8}>
                      <Box w='100%'>
                        <Text as='b'>ISI RINGKAS</Text><HSeparator mb='1' />{sumas.isisurat}<br /><br />
                        <Text as='b'>NOMOR SURAT</Text><HSeparator mb='1' />{sumas.nosurat}<br /><br />
                        <Grid templateColumns="repeat(2, 1fr)" gap={1}>
                          <Box w='100%'>
                            <Text as='b'>TANGGAL SURAT</Text><HSeparator mb='1' />{convertDate(sumas.tanggalsurat)}<br /><br />
                          </Box>
                          <Box w='100%'>
                            <Text as='b'>LAMPIRAN</Text><HSeparator mb='1' />{sumas.lampiran}<br /><br />
                          </Box>
                        </Grid>
                        <Text as='b'>ASAL SURAT & MEDIA PENGIRIMAN</Text><HSeparator mb='1' />{sumas.dari}<br /><br />

                      </Box>
                      <Box w='100%'>
                        <Text as='b'>PENGOLEH</Text>
                        <HSeparator mb='1' />
                        {sumas.pengoleh}<br /><br />
                        <Text as='b'>TUJUAN DISPOSISI</Text>
                        <HSeparator mb='2' />
                        <Stack spacing={1}>
                          {sumas.disposisike && sumas.disposisike.split(',').map((tujuan, index) => (
                            <Checkbox key={index} isChecked={true} isReadOnly>{tujuan}</Checkbox>
                          ))}
                        </Stack>
                      </Box>
                    </Grid>
                    <Grid>
                      <Box mb={6}>
                        <Text as='b'>ISI DISPOSISI DARI KALAPAS</Text>
                        <HSeparator mb='2' />
                        <Text border='2px dashed' borderColor='gray.400' borderRadius='16px' fontStyle='italic' p={5}>{'" ' + sumas.isidisposisi + ' "' || '-'}</Text>
                      </Box>
                      <Box>
                        <Text as='b'>FILE SURAT</Text>
                        <HSeparator mb='1' />
                        {sumas.extfile === 'null' || sumas.extfile === '' ? (
                          <Text color='red.500' fontStyle='italic'>File surat belum diupload</Text>
                        ) : (
                          <FileViewer
                            fileUrl={`${URL_WEB_BACKEND}/uploads/sumas/file/${sumas.verifid}_${sumas.id_user}.${sumas.extfile}`}
                            fileType={sumas.extfile}
                          />
                        )}
                        <br />
                      </Box>
                    </Grid>
                  </Card>
                </Td>
              </Tr>
            </>
          }
        </Tbody>
      </Table>}
    </Card>
  );
}
